<template>
  <div class="box3-page">
    <div class="inseec-title">核心优势</div>
    <div class="card-box">
      <div class="card-item" v-for="item in list1" :key="item.title">
        <img :src="item.img" alt="" />
        <h4>{{ item.title }}</h4>
        <p>{{ item.desc }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "",
    data() {
      return {
        list1: [
          {
            img: require("../../../assets/coursePage/inseec/box3/1.png"),
            title: "免考申请制入学",
            desc: "专科/本科可读的全法 TOP1 MBA 硕士",
          },
          {
            img: require("../../../assets/coursePage/inseec/box3/2.png"),
            title: "超高性价比",
            desc: "学费仅为传统留学的五分之一",
          },
          {
            img: require("../../../assets/coursePage/inseec/box3/3.png"),
            title: "在职学习 时间灵活",
            desc: "线上学习，契合职场人的生活节奏",
          },
          {
            img: require("../../../assets/coursePage/inseec/box3/4.png"),
            title: "实战课程体系",
            desc: "八大模块即学即用，管理思维科技商业",
          },
          {
            img: require("../../../assets/coursePage/inseec/box3/5.png"),
            title: "中文就读 自配速学",
            desc: "项目全中文可读，学习时间弹性",
          },
          {
            img: require("../../../assets/coursePage/inseec/box3/6.png"),
            title: "权威认证保障",
            desc: "三重认证，与线下留学相同的硕士学位证书",
          },
        ],
      };
    },
    methods: {},
  };
</script>

<style lang="scss" scoped>
  .box3-page {
    background: #f3f5f8;
    padding: 80px 40px;
    .inseec-title {
      font-weight: 600;
      font-size: 44px;
      color: #012d72;
      line-height: 64px;
      text-align: center;
    }
    .card-box {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 22px;
      margin-top: 48px;
      .card-item {
        background: #ffffff;
        border-radius: 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 40px 0;
        img {
          width: 92px;
          height: 92px;
          margin-bottom: 36px;
        }
        h4 {
          font-weight: 500;
          font-size: 32px;
          color: #092a52;
          line-height: 48px;
          text-align: center;
          margin-bottom: 12px;
        }
        p {
          font-weight: 400;
          font-size: 26px;
          color: #2f343d;
          line-height: 44px;
          text-align: center;
          padding: 0 24px;
        }
      }
    }
  }
</style>
